<template>
  <app-panel :title="$t('teacher.page.next_sessions_title')">
    <div class="grid gap-4">
      <template v-for="(course, index) in list" :key="course.id">
        <app-divider v-if="index > 0" />
        <course-list-item :course="course" />
      </template>
    </div>
  </app-panel>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";

defineProps<{
  list: CourseListView[];
}>();
</script>
